import React from 'react';

import { ClientFinances, TClientDetailsPaymentsInfo } from 'types/state';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { M8BillRow, M8LegalRequesites } from 'services/production/types';
import { ClientDetailsBillRow } from 'containers/ClientDetails/ClientDetailsBillRow';
import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { MarginComponent } from 'design/margin';
import { TextComponent } from 'design/text/textComponents';
import {
  SmallTableRowComponent,
  SmallTableWrapperComponent,
} from 'design/smallTable';

type Props = {
  paymentsInfo: TClientDetailsPaymentsInfo;
  legalRequesites: null | M8LegalRequesites;
  m8BillRows: M8BillRow[];
  finances: ClientFinances;
  onEditRefund(refundId: number): void;
  onManageBill(billId: number): void;
  onManageCardPayment(paymentId: number): void;
  onManageGiroPayment(paymentId: number): void;
};

export const ClientDetailsPayments = (props: Props) => {
  const {
    legalRequesites,
    m8BillRows,
    finances,
    onEditRefund,
    onManageBill,
    onManageCardPayment,
    onManageGiroPayment,
  } = props;

  const {
    shared: sharedDictionary,
    clientDetails: intl,
    missingTableDataFallbackText,
  } = useIntlDictionary();

  return (
    <>
      <SidebarModalSectionComponent
        content={
          <>
            <TextComponent size="mp" weight="medium">
              {intl.table.requesitesTitle}
            </TextComponent>
            <MarginComponent top={20} />
            <SmallTableWrapperComponent>
              <SmallTableRowComponent>
                <TextComponent>{intl.table.unpLabel}</TextComponent>
                <TextComponent>
                  {legalRequesites?.unp ? (
                    <TextComponent>{legalRequesites.unp}</TextComponent>
                  ) : (
                    <TextComponent color="secondary">
                      {missingTableDataFallbackText}
                    </TextComponent>
                  )}
                </TextComponent>
              </SmallTableRowComponent>
              <SmallTableRowComponent>
                <TextComponent>{intl.table.orgNameLabel}</TextComponent>
                <TextComponent>
                  {legalRequesites?.orgName ? (
                    <TextComponent>{legalRequesites.orgName}</TextComponent>
                  ) : (
                    <TextComponent color="secondary">
                      {missingTableDataFallbackText}
                    </TextComponent>
                  )}
                </TextComponent>
              </SmallTableRowComponent>
              <SmallTableRowComponent>
                <TextComponent>{intl.table.orgAdressLabel}</TextComponent>
                <TextComponent>
                  {legalRequesites?.orgAdress ? (
                    <TextComponent>{legalRequesites.orgAdress}</TextComponent>
                  ) : (
                    <TextComponent color="secondary">
                      {missingTableDataFallbackText}
                    </TextComponent>
                  )}
                </TextComponent>
              </SmallTableRowComponent>
            </SmallTableWrapperComponent>
          </>
        }
        actions={null}
      />
      <SidebarModalSectionComponent
        content={
          <>
            <MarginComponent top={20} />
            <SmallTableWrapperComponent>
              <SmallTableRowComponent>
                <TextComponent size="mp" weight="medium">
                  {intl.table.balanceLabel}
                </TextComponent>
                <TextComponent size="mp" weight="medium">
                  {sharedDictionary.moneyAmountText(
                    finances.balanceAmount,
                    'USD'
                  )}
                </TextComponent>
              </SmallTableRowComponent>
              <SmallTableRowComponent>
                <TextComponent>{intl.table.clientIncomeLabel}</TextComponent>
                <TextComponent>
                  {sharedDictionary.moneyAmountText(
                    finances.incomeAmount,
                    'USD'
                  )}
                </TextComponent>
              </SmallTableRowComponent>
              {finances.partnerPartAmount > 0 && (
                <SmallTableRowComponent>
                  <TextComponent>{intl.table.partnerPartLabel}</TextComponent>
                  <TextComponent>
                    {sharedDictionary.moneyAmountText(
                      finances.partnerPartAmount,
                      'USD'
                    )}
                  </TextComponent>
                </SmallTableRowComponent>
              )}
              {finances.agmPartAmount !== finances.incomeAmount && (
                <SmallTableRowComponent>
                  <TextComponent>{intl.table.agmPartLabel}</TextComponent>
                  <TextComponent>
                    {sharedDictionary.moneyAmountText(
                      finances.agmPartAmount,
                      'USD'
                    )}
                  </TextComponent>
                </SmallTableRowComponent>
              )}
            </SmallTableWrapperComponent>
          </>
        }
        actions={null}
      />
      <SidebarModalSectionComponent
        content={
          <>
            <TextComponent size="mp" weight="medium">
              {intl.table.transactionsInfoTitle}
            </TextComponent>
            <MarginComponent top={20} />
            <SmallTableWrapperComponent>
              {m8BillRows.map((m8BillRow) => (
                <ClientDetailsBillRow
                  key={m8BillRow.id}
                  m8BillRow={m8BillRow}
                  onEditRefund={onEditRefund}
                  onManageBill={onManageBill}
                  onManageGiroPayment={onManageGiroPayment}
                  onManageCardPayment={onManageCardPayment}
                />
              ))}
              {m8BillRows.length === 0 && (
                <TextComponent color="secondary">
                  {intl.table.transactionsFallbackValue}
                </TextComponent>
              )}
            </SmallTableWrapperComponent>
          </>
        }
        actions={null}
      />
    </>
  );
};
